// extracted by mini-css-extract-plugin
export default {"p_content":"_08c07896c5"};